import { render, staticRenderFns } from "./ResizeImageModal.vue?vue&type=template&id=890c7844&scoped=true"
import script from "./ResizeImageModal.vue?vue&type=script&lang=js"
export * from "./ResizeImageModal.vue?vue&type=script&lang=js"
import style0 from "./ResizeImageModal.vue?vue&type=style&index=0&id=890c7844&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "890c7844",
  null
  
)

export default component.exports